<template>
  <div :class="cssClass.parent">
    <input
      type="checkbox"
      :id="id"
      :name="name"
      :value="value"
      :checked="isChecked"
      :disabled="disabled"
      :class="cssClass.input"
      @change="change"
    />
    <label :for="id" :class="cssClass.label">
      <Icon2 variant="check" :size="14" />
      <div v-if="$slots.default" :class="cssClass.inner"><slot></slot></div>
    </label>
  </div>
</template>

<script>
import Icon2 from '@/components/Icon2';
export default {
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    checked: {
      type: [Array, Boolean, Number, String],
      required: true
    },
    disabled: {
      type: Boolean,
      required: false
    },
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: false
    },
    position: {
      type: String,
      required: false
    },
    value: {
      type: [Array, Boolean, Number, Object, String],
      required: false
    },
    variant: {
      type: String,
      required: false
    }
  },
  components: {
    Icon2
  },
  computed: {
    cssClass() {
      return {
        parent: {
          'c-checkbox': true,
          'c-checkbox--only': !this.$slots.default,
          ['c-checkbox--' + this.position]: this.position,
          ['c-checkbox--' + this.variant]: this.variant
        },
        inner: {
          'c-checkbox__inner': true,
          ['c-checkbox--' + this.position + '__inner']: this.position,
          ['c-checkbox--' + this.variant + '__inner']: this.variant
        },
        input: {
          'c-checkbox__input': true,
          ['c-checkbox--' + this.position + '__input']: this.position,
          ['c-checkbox--' + this.variant + '__input']: this.variant
        },
        label: {
          'c-checkbox__label': true,
          ['c-checkbox--' + this.position + '__label']: this.position,
          ['c-checkbox--' + this.variant + '__label']: this.variant
        }
      };
    },
    isArray() {
      return Array.isArray(this.checked);
    },
    isChecked() {
      if (this.isArray) {
        return this.checked.indexOf(this.value) !== -1;
      } else {
        return this.checked;
      }
    }
  },
  methods: {
    change() {
      let checked = !this.isChecked;

      if (this.isArray) {
        let index = this.checked.indexOf(this.value);
        let array = this.checked.slice();
        if (checked && index === -1) {
          array.push(this.value);
        } else if (!checked && index !== -1) {
          array.splice(index, 1);
        }
        this.$emit('change', array);
      } else {
        this.$emit('change', checked);
      }
    }
  }
};
</script>
